/* BEUSEA hand visualizer - product gallery tile */
(function () {
  if (window.__bsaHvProduct) return; window.__bsaHvProduct = 1;
  var CDN = "https://www.beusea.com/cdn/shop/files/";
  var SHAPES = [
    {k:"round",   n:"Round",   de:"Rund",     L:6.50, W:6.50, m:/round|rund/i},
    {k:"oval",    n:"Oval",    de:"Oval",     L:7.70, W:5.50, m:/oval/i},
    {k:"cushion", n:"Cushion", de:"Kissen",   L:5.60, W:5.60, m:/cushion|kissen/i},
    {k:"princess",n:"Princess",de:"Prinzess", L:5.50, W:5.50, m:/princess|prinzess/i},
    {k:"pear",    n:"Pear",    de:"Tropfen",  L:8.00, W:5.30, m:/pear|tropfen|birne/i},
    {k:"heart",   n:"Heart",   de:"Herz",     L:6.50, W:6.50, m:/heart|herz/i},
    {k:"emerald", n:"Emerald", de:"Smaragd",  L:7.00, W:5.00, m:/emerald|smaragd/i},
    {k:"marquise",n:"Marquise",de:"Navette",  L:10.00,W:5.00, m:/marquise|navette/i},
    {k:"radiant", n:"Radiant", de:"Radiant",  L:6.10, W:5.30, m:/radiant/i},
    {k:"asscher", n:"Asscher", de:"Asscher",  L:5.50, W:5.50, m:/asscher/i}
  ];
  var CTS=[0.2,0.25,0.3,0.4,0.5,0.6,0.7,0.75,0.8,0.9,1,1.1,1.2,1.25,1.3,1.4,1.5,1.6,1.7,1.75,1.8,1.9,2,2.25,2.5,2.75,3,3.25,3.5,3.75,4,4.5,5,5.5,6,6.5,7,7.5,8,9,10,11,12,13,14,15];
  var PCT_PER_MM = 3.70/1024*100, CX=56.01, CY=43.46;
  var DE = (document.documentElement.lang||"").toLowerCase().indexOf("de") === 0;
  var T = DE
    ? {t:"An der Hand ansehen", c:"Karat", s:"Hautton", note:"Ringgr\u00f6\u00dfe 52 EU \u00b7 typische Ma\u00dfe f\u00fcr einen gut geschliffenen Stein"}
    : {t:"See it on a hand",    c:"Carat", s:"Skin tone", note:"Ring size 52 EU \u00b7 typical dimensions for a well-cut stone"};

  var css = ""
  + ".bsahp{display:flex;flex-direction:column;background:#faf8f4;border:1px solid #e2ded4;padding:14px;box-sizing:border-box;font-family:inherit;color:#1a1a1a;height:100%}"
  + ".bsahp *{box-sizing:border-box}"
  + ".bsahp__t{font-size:10px;letter-spacing:.16em;text-transform:uppercase;color:#8a8578;text-align:center;margin:0 0 10px}"
  + ".bsahp__stage{position:relative;width:100%;aspect-ratio:1/1;overflow:hidden;background:#f2efe8}"
  + ".bsahp__stage img.h{position:absolute;inset:0;width:100%;height:100%;object-fit:cover;display:block}"
  + ".bsahp__st{position:absolute;transform:translate(-50%,-50%);pointer-events:none;filter:drop-shadow(0 1px 1.5px rgba(60,45,30,.45));transition:width .18s ease,height .18s ease}"
  + ".bsahp__st img{width:100%;height:100%;display:block}"
  + ".bsahp__row{display:flex;align-items:center;gap:9px;margin-top:10px}"
  + ".bsahp__row label{font-size:9px;letter-spacing:.14em;text-transform:uppercase;color:#8a8578;width:58px;flex:0 0 58px}"
  + ".bsahp__row input[type=range]{-webkit-appearance:none;appearance:none;background:transparent;flex:1;height:22px;margin:0;min-width:0}"
  + ".bsahp__row input[type=range]::-webkit-slider-runnable-track{height:2px;background:#e2ded4}"
  + ".bsahp__row input[type=range]::-moz-range-track{height:2px;background:#e2ded4}"
  + ".bsahp__row input[type=range]::-webkit-slider-thumb{-webkit-appearance:none;width:17px;height:17px;border-radius:50%;background:#fff;border:1px solid #cfc9ba;box-shadow:0 1px 3px rgba(0,0,0,.18);margin-top:-7.5px}"
  + ".bsahp__row input[type=range]::-moz-range-thumb{width:17px;height:17px;border-radius:50%;background:#fff;border:1px solid #cfc9ba;box-shadow:0 1px 3px rgba(0,0,0,.18)}"
  + ".bsahp__v{font-size:11px;width:44px;text-align:right;flex:0 0 44px;letter-spacing:.02em}"
  + ".bsahp__shapes{display:flex;flex-wrap:wrap;justify-content:center;gap:2px;margin-top:11px;padding-top:10px;border-top:1px solid #e2ded4}"
  + ".bsahp__sh{background:none;border:1px solid transparent;padding:4px 3px 3px;width:46px;cursor:pointer;display:flex;flex-direction:column;align-items:center;gap:3px;font:inherit;border-radius:2px}"
  + ".bsahp__sh img{width:19px;height:19px;object-fit:contain;filter:saturate(.15)}"
  + ".bsahp__sh span{font-size:7.5px;letter-spacing:.07em;text-transform:uppercase;color:#8a8578;line-height:1}"
  + ".bsahp__sh[aria-pressed=true]{border-color:#cfc9ba;background:#fff}"
  + ".bsahp__sh[aria-pressed=true] img{filter:none}.bsahp__sh[aria-pressed=true] span{color:#1a1a1a}"
  + ".bsahp__cap{text-align:center;font-size:11px;margin:10px 0 0;letter-spacing:.04em}"
  + ".bsahp__cap b{text-transform:uppercase;letter-spacing:.1em;font-weight:600}"
  + ".bsahp__cap i{font-style:normal;color:#8a8578}"
  + ".bsahp__note{text-align:center;font-size:9.5px;color:#8a8578;margin:5px 0 0;line-height:1.5}";

  function detectShape() {
    var title = (document.querySelector('h1') || {}).textContent || document.title || "";
    for (var i=0;i<SHAPES.length;i++) if (SHAPES[i].m.test(title)) return i;
    return 0;
  }
  function nearestCt(v) {
    var best=22, d=1e9;
    for (var i=0;i<CTS.length;i++){ var x=Math.abs(CTS[i]-v); if(x<d){d=x;best=i;} }
    return best;
  }
  // read the checked "carat" variant radio (option named Karat / Carat / Centre stone)
  function readVariantCt() {
    var ins = document.querySelectorAll('input[type=radio]:checked, select');
    for (var i=0;i<ins.length;i++){
      var v = (ins[i].value||"").trim();
      if (/^\d+(\.\d+)?$/.test(v)) {
        var num = parseFloat(v);
        if (num >= 0.15 && num <= 30) {
          var name = (ins[i].name||"") + " " + ((ins[i].closest('fieldset')||{}).textContent||"");
          if (/karat|carat|stein|stone/i.test(name) || num <= 15) return num;
        }
      }
    }
    return null;
  }

  function build(ul) {
    var li = document.createElement('li');
    li.className = (ul.children[0] ? ul.children[0].className : '').replace(/is-active/g,'').trim();
    li.setAttribute('data-bsa-tile','1');
    li.style.scrollSnapAlign='start';

    var st = document.createElement('style'); st.textContent = css; document.head.appendChild(st);

    var wrap = document.createElement('div'); wrap.className='bsahp';
    wrap.innerHTML =
      '<p class="bsahp__t">'+T.t+'</p>'
    + '<div class="bsahp__stage"><img class="h" alt=""><span class="bsahp__st"><img alt=""></span></div>'
    + '<div class="bsahp__row"><label>'+T.c+'</label><input type="range" min="0" max="'+(CTS.length-1)+'" step="1" value="22" aria-label="'+T.c+'"><span class="bsahp__v"></span></div>'
    + '<div class="bsahp__row"><label>'+T.s+'</label><input type="range" min="1" max="6" step="1" value="3" aria-label="'+T.s+'"><span class="bsahp__v"></span></div>'
    + '<div class="bsahp__shapes"></div><p class="bsahp__cap"></p><p class="bsahp__note">'+T.note+'</p>';
    li.appendChild(wrap);

    var hand = wrap.querySelector('img.h'),
        stone = wrap.querySelector('.bsahp__st'),
        stoneImg = stone.querySelector('img'),
        rows = wrap.querySelectorAll('.bsahp__row'),
        ct = rows[0].querySelector('input'), ctv = rows[0].querySelector('.bsahp__v'),
        tone = rows[1].querySelector('input'),
        shapesEl = wrap.querySelector('.bsahp__shapes'),
        cap = wrap.querySelector('.bsahp__cap');

    var cur = detectShape();
    SHAPES.forEach(function (s, i) {
      var b = document.createElement('button');
      b.type='button'; b.className='bsahp__sh'; b.setAttribute('aria-pressed', i===cur?'true':'false');
      b.innerHTML = '<img src="'+CDN+'stone-'+s.k+'.webp" alt="" loading="lazy"><span>'+(DE?s.de:s.n)+'</span>';
      b.addEventListener('click', function(){ cur=i;
        [].forEach.call(shapesEl.children,function(c,j){c.setAttribute('aria-pressed', j===i?'true':'false')});
        render(); });
      shapesEl.appendChild(b);
    });

    function fmtCt(v){ return (v%1===0? v.toFixed(0) : (v*100%10===0? v.toFixed(1): v.toFixed(2))) + "ct"; }
    function render(){
      var s=SHAPES[cur], c=CTS[+ct.value], k=Math.cbrt(c);
      var mmL=s.L*k, mmW=s.W*k;
      stoneImg.src = CDN+"stone-"+s.k+".webp";
      stoneImg.alt = (DE?s.de:s.n)+" "+fmtCt(c);
      stone.style.width=(mmW*PCT_PER_MM)+"%"; stone.style.height=(mmL*PCT_PER_MM)+"%";
      stone.style.left=CX+"%"; stone.style.top=CY+"%";
      hand.src = CDN+"hand-"+tone.value+".jpg";
      ctv.textContent = fmtCt(c);
      cap.innerHTML = "<b>"+(DE?s.de:s.n)+"</b> &nbsp;<i>"+fmtCt(c)+" &nbsp;·&nbsp; "+mmL.toFixed(2)+" &times; "+mmW.toFixed(2)+"mm</i>";
    }
    ct.addEventListener('input',render); tone.addEventListener('input',render);

    function syncVariant(){
      var v = readVariantCt();
      if (v!=null) { ct.value = nearestCt(v); }
      var s = detectShape();
      if (s !== cur) { cur = s;
        [].forEach.call(shapesEl.children,function(c,j){c.setAttribute('aria-pressed', j===cur?'true':'false')}); }
      render();
    }
    syncVariant();
    document.addEventListener('change', function(e){
      if (e.target && e.target.matches && e.target.matches('input[type=radio],select')) setTimeout(syncVariant,60);
    }, true);
    document.addEventListener('click', function(e){
      if (e.target && e.target.closest && e.target.closest('.product-form__input')) setTimeout(syncVariant,120);
    }, true);

    for (var i=1;i<=6;i++){ var im=new Image(); im.src=CDN+"hand-"+i+".jpg"; }

    var at = Math.min(2, ul.children.length);
    if (ul.children[at]) ul.insertBefore(li, ul.children[at]); else ul.appendChild(li);
  }

  function boot(tries){
    var ul = document.querySelector('ul.product__media-list');
    if (ul && !ul.querySelector('[data-bsa-tile]')) { build(ul); return; }
    if ((tries||0) < 40) setTimeout(function(){ boot((tries||0)+1); }, 250);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function(){boot(0)});
  else boot(0);
})();
